export default __webpack_public_path__ + "static/media/second.44ebb651.m4a";